import React from 'react';
import tw from 'twin.macro';

const DateLabel = ({ dateTime, date, ...style }) => (
  <time
    dateTime={dateTime}
    tw="inline-block text-xs font-normal px-2 py-1 my-2 md:my-5 bg-white-50"
    {...style}
  >
    {date}
  </time>
);

export default DateLabel;
